import React from "react";
import { FormValue } from "../BuildingSettingsStore";
import { useTranslation } from "react-i18next";
import TextInput from "components/TextInput";
import { M2_NGF_UNIT } from "utils";

const BNB = (props: {
  netFloorArea?: number | null;
  onChange?: (value: FormValue, name?: string) => void;
  hasError?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white p-4 border-b">
      <TextInput
        type="number"
        placeholder={t("buildingSettings.pleaseSpecifyTheArea")}
        labelName={t("buildingSettings.netFloorArea")}
        noMargin
        value={String(props.netFloorArea ?? "")}
        handleChange={(value) => props.onChange?.(value, "net_floor_area")}
        helper={t("buildingSettings.netFloorAreaHelper")}
        required
        unit={M2_NGF_UNIT}
        showMandatoryAlert={props.hasError && !props.netFloorArea}
      />
    </div>
  );
};

export default BNB;
